module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-UltraLight.2e8d0863.eot";